<div class="container error_page">
    <h2 class="error_title">{{ "Everything is okay." | translate }}</h2>
    <h3 class="error_title">{{ "We are releasing new version. The service temporaryly is not available." | translate }}</h3>
    <h4 class="error_title">{{ "Check back later. Anticipated time service to be restored is" | translate }} <b>08:00 PM UTC, April 10, 2022</b></h4>
    <img src="{{ imgRoute }}assets/img/repair.jpg" alt="">
</div>